// src/services/payrollService.js
import { api } from './api';

export const payrollService = {
  // Run a new monthly payroll batch
  runPayroll: (month, year) => 
    api.post('/api/payroll/run', { month, year }),

  // Get list of all payroll batches
  getBatches: () => 
    api.get('/api/payroll/batches'),

  // Get details of a specific batch
  getBatch: (id) => 
    api.get('/api/payroll/batches/' + id),

  // Feature: edit one employee's payroll figures within a batch (before it's Paid)
  updateRecord: (batchId, employeeId, data) =>
    api.put('/api/payroll/batches/' + batchId + '/records/' + employeeId, data),

  // Finance Manager reviews the batch
  reviewBatch: (id) => 
    api.put('/api/payroll/batches/' + id + '/review', {}),

  // CEO approves the batch (triggers payslip generation)
  approveBatch: (id) => 
    api.put('/api/payroll/batches/' + id + '/approve', {}),

  // Employee: Get own payslips
  getMyPayslips: () => 
    api.get('/api/payroll/payslips/my'),

  // Returns the raw fetch Response (unresolved) for a payslip PDF, so
  // callers can check response.ok before reading the blob (SelfService.jsx).
  getPayslipBlob: (payslipId) => {
    const token = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    return fetch(baseUrl + '/api/payroll/payslips/' + payslipId + '/download', {
      headers: token ? { Authorization: 'Bearer ' + token } : {},
    });
  },

  // Opens the payslip PDF in a new tab (authenticated) — viewable and
  // printable straight from the browser's native PDF viewer.
  viewPayslip: async (id) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    const token = localStorage.getItem('access_token');

    const res = await fetch(baseUrl + '/api/payroll/payslips/' + id + '/download', {
      headers: token ? { Authorization: 'Bearer ' + token } : {},
    });
    if (!res.ok) throw new Error('Failed to load payslip');

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
  },
};